import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import useStyles from '../../index.style';
import PropTypes from 'prop-types';
import { Add, BubbleChart } from '@material-ui/icons';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { generateFreeDownloadItem } from 'redux/actions/Movies';

const DownloadItemHeader = () => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);

  const downloadId = params.get('download');
  const downloadType = params.get('type');
  const movieName = params.get('name');
  const downloadUID = params.get('ui');

  const { isCreatedDwonload, downloadItems } = useSelector(({ movies }) => movies);

  return (
    <Box className={classes.inBuildAppHeader}>
      <Box className={classes.inBuildAppHeaderSidebar}>
        <Typography className={classes.inBuildAppHeaderTitle} component="div" variant="h1">
          دانلود آیتم‌ها
        </Typography>
      </Box>

      <Box className={classes.inBuildAppHeaderContent}>
        <Box ml="auto" display="flex" alignItems="center">
          <Box ml={1}>
            <Button
              disabled={!isCreatedDwonload}
              variant="contained"
              color="secondary"
              href={`/create-movie/?p=${downloadId}&type=${downloadType}&name=${movieName}&downloadUID=${downloadUID}`}
              endIcon={<Add />}>
              ساخت دانلود آیتم
            </Button>
          </Box>
          <Box ml={1}>
            <Button
              disabled={!isCreatedDwonload && downloadItems.length <= 0}
              variant="contained"
              color="secondary"
              onClick={() => dispatch(generateFreeDownloadItem(downloadId))}
              endIcon={<BubbleChart />}>
              تولید دانلود آیتم رایگان
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadItemHeader;

DownloadItemHeader.prototype = {
  onChangeViewMode: PropTypes.func,
};
